export default __webpack_public_path__ + "static/media/partners-logo-ewha-w.fe2c2804.webp";